import { MODIFIERS_V2 } from 'constants/featureFlags';

export function hasModifiersV2FeatureFlag(betaFeatureFlags) {
  if (betaFeatureFlags) {
    return betaFeatureFlags.includes(MODIFIERS_V2);
  }
  return false;
}
